import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 5
    },
    billTo: {
        color: '#000',
        fontSize: 20,
        textAlign: 'center',
    },
  });


  const BillVoucher = ({invoice}) => (
    <View style={styles.headerContainer}>
        <Text style={styles.billTo}> Payment Voucher</Text>
    </View>
  );
  
  export default BillVoucher